import { useContext } from 'react'
import { OptimizelyContext } from '../OptimizelyContext'
import { OptimizelyFeatureFlags, OptimizelyDecisionWithoutUserContext } from 'models/optimizely'

export const useFeatureFlag = (
  flagName: OptimizelyFeatureFlags,
): OptimizelyDecisionWithoutUserContext => {
  const featureFlags = useContext(OptimizelyContext)

  // Get the decision from Optimizely context (includes any URL overrides from server-side)
  const decision = featureFlags[flagName] || {
    enabled: false,
    flagKey: flagName,
    variationKey: null,
    variables: {},
    ruleKey: null,
    reasons: [],
  }

  return decision
}
